import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import CardActionArea from '@material-ui/core/CardActionArea';
import CardContent from '@material-ui/core/CardContent';
import CardMedia from '@material-ui/core/CardMedia';
import {Heading6, Body2} from '../../../typography/typography';
import CardActions from '@material-ui/core/CardActions';
import Button from '@material-ui/core/Button';
import { useHistory } from 'react-router-dom';

const useStyles = makeStyles((theme)=>({
  root: {
    maxWidth: 345,
    minWidth: 345,
    marginBottom: "1.5rem",
  },
}));

export default function ImgMediaCard({src, title, text, projects, reviews}) {
  const classes = useStyles(reviews);
  const history = useHistory();

  const projectClickHandler = (title) => {
    title = title.toLowerCase().replace(/\s/g, '');
    history.push(`/projects/${title}`);
}

  const mainCard = () => (
    <>
      <CardMedia
      component="img"
      height={reviews? "180" : "140"}
      image={src}
      style={{objectFit: projects || reviews ? "contain" : "cover", padding: projects && "1rem 0" , cursor: reviews && "default" }}
    />
    <CardContent>
      <Heading6 gutterBottom variant="h6" component="h2" style={{display: "flex", justifyContent: projects && "center"}}>
        {title}
      </Heading6>
      <Body2 variant="body2" color="textSecondary" component="p">
        {text}
      </Body2>
    </CardContent>
  </>
  )

  return (
    <Card className={classes.root} style={{minHeight: reviews && 400 }}>

      {reviews ? mainCard() : 
      <CardActionArea>
        {mainCard()}
      </CardActionArea>}

        {projects && <CardActions>
        <Button size="small" style={{color: "#eec653"}} onClick={() => projectClickHandler(title)}>
          Explore
        </Button>
      </CardActions>}
    </Card>
  );
}
